@use 'themes/westfield' as *;
// Loading spinner styles
// ======================

@use 'tools/dirg' as *;
@use 'tools/color' as *;

.SpinnerDefault {
  animation: SpinnerDefault 1s infinite linear;
  display: inline-block;
  width: units(1);
  height: units(1);
  color: #3d3935;
}

@keyframes SpinnerDefault {
  from {
    transform: rotateZ(0);
  }

  to {
    transform: rotateZ(359deg);
  }
}

.SpinnerLarge {
  width: calc(40px + 3.2vw);
  height: calc(40px + 3.2vw);
  content: '';
  box-sizing: border-box;
  top: 128px;
  left: 50%;
  border-radius: 50%;
  border: 6px solid color('Grey Light');
  border-top: 6px solid color('Brand');
  animation: SpinnerLarge 0.6s linear infinite;
  margin: 25vh auto;
}

@keyframes SpinnerLarge {
  to {
    transform: rotate(360deg);
  }
}

.SpinnerSeasonal {
  &.SpinnerDefault {
    color: color('Seasonal');
  }

  &.SpinnerLarge {
    border-top: 6px solid color('Seasonal');
  }
}
